import { render, staticRenderFns } from "./MovableImagePropertyEditor.vue?vue&type=template&id=3c7ae5ec&scoped=true&"
import script from "./MovableImagePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./MovableImagePropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ae5ec",
  null
  
)

export default component.exports